<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { SessionExpiredDialog, t } from "@gaming/shared";
import { useBranding } from "./composables/useBranding";

const { loaded, unavailable, load } = useBranding();
const router = useRouter();

// Branding is resolved from the hostname before anything renders, so the site
// never flashes a generic skin before becoming itself.
onMounted(load);

// Carry where they were, so signing in returns them to it rather than the lobby.
function toLogin(route) {
  router.push({ ...route, query: { expired: "1", redirect: router.currentRoute.value.fullPath } });
}
</script>

<template>
  <div v-if="!loaded" class="min-h-screen flex items-center justify-center">
    <span class="text-sm text-content-muted">{{ t("common.loading") }}</span>
  </div>

  <!--
    An unknown hostname or a suspended whitelabel must NOT fall through to a
    generic site that keeps taking registrations under a brand that is not
    trading.
  -->
  <div v-else-if="unavailable" class="min-h-screen flex items-center justify-center p-6">
    <div class="card p-8 max-w-sm text-center">
      <h1 class="text-lg font-semibold text-content">{{ t("misc.siteUnavailable_title") }}</h1>
      <p class="text-sm text-content-muted mt-2">
        {{ t("misc.siteUnavailable") }}
      </p>
    </div>
  </div>

  <RouterView v-else />

  <!--
    Outside the branding gate: a session can lapse while the site is perfectly
    fine, and the notice has to reach the player either way.
  -->
  <SessionExpiredDialog @signin="toLogin" />
</template>
